import { CustomerScopeSelector } from "portal/components/customers/CustomerScopeSelector";
import { getPlantProfilesPath } from "portal/utils/routing";
import { Header } from "portal/components/header/Header";
import { Page } from "portal/components/Page";
import { PlantProfile } from "portal/components/categoryCollectionProfile/PlantProfile";
import { portalEndpoints } from "portal/state/portalApi";
import { useCustomerScopeFilter } from "portal/components/customers/useCustomerScopeFilter";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

export const PlantProfilePage: FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { customerUuid } = useCustomerScopeFilter();

  return (
    <>
      <Header title={t("views.plantProfiles.title")}>
        <CustomerScopeSelector readOnly value={customerUuid} />
      </Header>
      <Page>
        {customerUuid && id && (
          <PlantProfile
            uuid={id}
            customerUuid={customerUuid}
            parentLink={getPlantProfilesPath(customerUuid)}
            useSetMutation={
              portalEndpoints.applyCustomerPlantProfileChanges.useMutation
            }
          />
        )}
      </Page>
    </>
  );
};
